/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Source_LanguageInputs */



/**
* | output |
* | --- |
* | "Select the source language for transcription" |
*
* @param {Select_Source_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_source_language = /** @type {((inputs?: Select_Source_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Source_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez la langue source pour la transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Ausgangssprache für die Transkription aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la lingua di origine per la trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите исходный язык для транскрипции.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el idioma de origen para la transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要转录的源语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写のソース言語を選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेखन के लिए स्रोत भाषा का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o idioma de origem para transcrição.")
	return /** @type {LocalizedString} */ ("Select the source language for transcription")
});